/**
 * Четыре рычага выручки: R = L × C × P × Q
 *
 * L — сколько человек к вам обратилось
 * C — какая часть из них купила
 * P — сколько в среднем платит один за покупку
 * Q — сколько раз покупает за период
 *
 * Ранжирование по скорости эффекта одинаково для всех ниш и клиентов.
 */

export const LEVER = {
  PRICE: 'p',
  CONVERSION: 'c',
  LEADS: 'l',
  FREQUENCY: 'q',
};

export const LEVERS = [
  {
    id: LEVER.PRICE,
    rank: 1,
    label: 'Средний чек',
    plainLabel: 'Сколько в среднем платит один клиент',
    action: 'Продавать дороже или больше за один раз',
    how: 'Допродажа, работа с продавцом, пересмотр цен',
    timing: { min: 2, max: 4, unit: 'weeks', label: '2–4 недели' },
    timingMonths: { min: 0.5, max: 1 },
  },
  {
    id: LEVER.CONVERSION,
    rank: 2,
    label: 'Конверсия',
    plainLabel: 'Какая часть обратившихся покупает',
    action: 'Доводить до покупки больше тех, кто уже обратился',
    how: 'Скрипты продаж, скорость ответа, работа с возражениями',
    timing: { min: 1, max: 2, unit: 'months', label: '1–2 месяца' },
    timingMonths: { min: 1, max: 2 },
  },
  {
    id: LEVER.LEADS,
    rank: 3,
    label: 'Поток обращений',
    plainLabel: 'Сколько человек к вам обращается',
    action: 'Привлекать больше обращений',
    how: 'Расширение рекламы, новые каналы — обычно требует бюджета',
    timing: { min: 1, max: 3, unit: 'months', label: '1–3 месяца' },
    timingMonths: { min: 1, max: 3 },
  },
  {
    id: LEVER.FREQUENCY,
    rank: 4,
    label: 'Частота покупок',
    plainLabel: 'Как часто клиент возвращается',
    action: 'Возвращать клиентов чаще',
    how: 'Напоминания, программа лояльности, работа с базой',
    timing: { min: 3, max: 6, unit: 'months', label: '3–6 месяцев и дольше' },
    timingMonths: { min: 3, max: 6 },
  },
];

export const LEVER_MAP = LEVERS.reduce((acc, lever) => {
  acc[lever.id] = lever;
  return acc;
}, {});

export const getLever = (leverId) => LEVER_MAP[leverId] || null;

/** Рычаги в порядке возрастания сложности: чек → конверсия → поток → частота. */
export const LEVERS_BY_RANK = [...LEVERS].sort((a, b) => a.rank - b.rank);

/**
 * Оценка времени по самому долгому рычагу сценария при параллельной работе.
 */
export const estimateScenarioTiming = (leverIds) => {
  const involved = leverIds.map(getLever).filter(Boolean);

  if (!involved.length) {
    return { label: '—', minMonths: 0, maxMonths: 0 };
  }

  const slowest = involved.reduce((acc, lever) =>
    lever.timingMonths.max > acc.timingMonths.max ? lever : acc,
  );

  return {
    label: slowest.timing.label,
    minMonths: slowest.timingMonths.min,
    maxMonths: slowest.timingMonths.max,
    drivenBy: slowest.id,
  };
};

export const TIMING_DISCLAIMER =
  'Это оценка при обычном темпе работы. Если наймёте специалиста — будет ближе к меньшему сроку, ' +
  'если делаете всё сами без свободных рук — ближе к большему.';
